import {Component} from '@angular/core';
import {RouterLink} from '@angular/router';
import {HubApiService} from '../../services/hub-api.service';

@Component({
  selector: 'hub-dashboard',
  imports: [RouterLink],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {
  constructor(private hubApi: HubApiService) {
  }

  t(key: string): string {
    return this.hubApi.translate(key) || key;
  }
}
